import { useContext } from "react";
import { StaffAuthContext } from "./StaffAuthContext";

export const useStaffAuthContext = () => {
    const context = useContext(StaffAuthContext);
    if(!context){
        throw Error('useStaffAuthContext must be used inside staff pages');
    }
    return context;
}